// Module
var code = "<md-toast id=\"sync-event-toast\"><span class=\"md-toast-text\" flex>{{$ctrl.isUpdate && ('feedback-session-slide-presentation-viewer_slide-timing-updated' | translate) || ('feedback-session-slide-presentation-viewer_slide-timing-saved' | translate)}}</span></md-toast>";
// Exports
module.exports = code;